import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEditEquipment extends Layout {
    panelComments: Panel;
    sourceDriver: DataSource;
    sourceDriver2: DataSource;
    sourceOrders: DataSource;
    sourceTractor: DataSource;
    sourceTrailer: DataSource;
    sourceTrailer2: DataSource;
    sourceTrailer3: DataSource;
    textboxDriverPlanningComment: Textbox;
    textboxDriver2PlanningComment: Textbox;
    textboxOrderPlanningComment: Textbox;
    textboxTractorPlanningComment: Textbox;
    textboxTrailerPlanningComment: Textbox;
    textboxTrailer2PlanningComment: Textbox;
    textboxTrailer3PlanningComment: Textbox;
}
